import { render, staticRenderFns } from "./DiyList.vue?vue&type=template&id=96c3fb24&scoped=true&"
import script from "./DiyList.vue?vue&type=script&lang=js&"
export * from "./DiyList.vue?vue&type=script&lang=js&"
import style0 from "./DiyList.vue?vue&type=style&index=0&id=96c3fb24&lang=scss&scoped=true&"
import style1 from "./DiyList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c3fb24",
  null
  
)

export default component.exports